import React from 'react';
import { DashboardIcon } from '../../components/ui/DashboardIcon';
import { changePassword } from '../../services/auth';

export function ChangePassword() {
  const [currentPassword, setCurrentPassword] = React.useState('');
  const [newPassword, setNewPassword] = React.useState('');
  const [confirmation, setConfirmation] = React.useState('');
  const [error, setError] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');

    if (newPassword.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }

    if (newPassword !== confirmation) {
      setError('New password and confirmation do not match.');
      return;
    }

    if (currentPassword === newPassword) {
      setError('New password must be different from your current password.');
      return;
    }

    setIsSubmitting(true);
    try {
      await changePassword(currentPassword, newPassword);
      window.dispatchEvent(new CustomEvent('responseops.auth-expired', {
        detail: { message: 'Password changed successfully. Please sign in again.' },
      }));
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : 'Unable to change password');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="change-password-page">
      <div className="change-password-card">
        <div className="change-password-heading">
          <span className="change-password-icon" aria-hidden="true">
            <DashboardIcon type="lock" size={24} />
          </span>
          <div>
            <h2>Change password</h2>
            <p>After changing your password, you will be signed out from this session.</p>
          </div>
        </div>

        {error ? <div className="kyc-message passengers-error" role="alert">{error}</div> : null}

        <form onSubmit={submit}>
          <div className="form-group">
            <label htmlFor="current-password">Current password</label>
            <input
              autoComplete="current-password"
              disabled={isSubmitting}
              id="current-password"
              onChange={(event) => setCurrentPassword(event.target.value)}
              required
              type="password"
              value={currentPassword}
            />
          </div>
          <div className="form-group">
            <label htmlFor="new-password">New password</label>
            <input
              autoComplete="new-password"
              disabled={isSubmitting}
              id="new-password"
              minLength={8}
              onChange={(event) => setNewPassword(event.target.value)}
              required
              type="password"
              value={newPassword}
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirm new password</label>
            <input
              autoComplete="new-password"
              disabled={isSubmitting}
              id="confirm-password"
              minLength={8}
              onChange={(event) => setConfirmation(event.target.value)}
              required
              type="password"
              value={confirmation}
            />
          </div>
          <button className="btn btn-primary change-password-submit" disabled={isSubmitting} type="submit">
            {isSubmitting ? 'Changing password...' : 'Change password'}
          </button>
        </form>
      </div>
    </div>
  );
}
